/**
 *  弹出框
 *
 */
'use strict';
angular.module('transmissionModule', []).controller('transmissionController', ['$scope', 'draftParams', '$modalInstance', 'messagePublishService',
    function($scope, draftParams, $modalInstance, messagePublishService) {
        initStatus();

        /**
         * [initStatus description]
         * @return {[type]} [description]
         */
        function initStatus() {
            messagePublishService.subscribe('closeTrans', function() {
                $modalInstance.dismiss();
            }, $scope);
        }

        /**
         * [cancel description] 取消
         * @return {[type]} [description]
         */
        $scope.cancel = function() {
            $modalInstance.dismiss();
        };
    },
]);
